import { render, staticRenderFns } from "./UploadCourseVideo.vue?vue&type=template&id=0790636e&scoped=true"
import script from "./UploadCourseVideo.vue?vue&type=script&lang=js"
export * from "./UploadCourseVideo.vue?vue&type=script&lang=js"
import style0 from "./UploadCourseVideo.vue?vue&type=style&index=0&id=0790636e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0790636e",
  null
  
)

export default component.exports